import React, { useReducer } from 'react'
import SellerPayoutContext from './sellerPayoutContext'
import SellerPayoutReducer from './sellerPayoutReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_PAYOUT_LOGS,
    GET_ALL_PAYOUT_LOGS_ZB,
    GET_ALL_TRANS_LOGS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_TRANS_LOGS_ZB,
} from './sellerPayoutTypes'

const TransactionState = (props) => {
    const initialState = {
        all_payment: {
            records: [],
            totalRecords: 0,
            summary: {},
            setDisp: '',
        },
        all_payment_zb: {
            records: [],
            totalRecords: 0,
            summary: {},
            setDisp: '',
        },
        all_trans_zb: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        all_trans: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(SellerPayoutReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllSellerPayoutLogs = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllSellerPayoutLogs',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            const from = 'getAllSellerPayoutLogs'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PAYOUT_LOGS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        summary: res.data.data.responseData.summary,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllSellerPayoutLogsZb = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllZbPayoutLogs',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            const from = 'getAllSellerPayoutLogs'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_PAYOUT_LOGS_ZB,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        summary: res.data.data.responseData.summary,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllTransaction = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllSellerPayoutTransaction',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            const from = 'Invoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_TRANS_LOGS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllTransactionZb = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'getAllZbPayoutTransaction',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            const from = 'Invoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_TRANS_LOGS_ZB,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const sellerTransfer = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'sellerTransfer'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'sellerTransferFee',
                    formData,
                    '',
                    'third_party/payment/stripe/seller'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const updateInvoiceSellerStatus = async (formData, fromVariable) => {
        try {
            const from = fromVariable
                ? fromVariable
                : 'updateInvoiceSellerStatus'

            const [res] = await Promise.all([
                apiCall('post', 'invoiceAction', formData, '', 'invoice'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateSellerPayoutLogs = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'updateSellerPayoutLogs'

            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'updateSellerPayoutLogs',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateZipperBuyPayoutLogs = async (formData, fromVariable) => {
        try {
            const from = fromVariable
                ? fromVariable
                : 'updateZipperBuyPayoutLogs'

            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'updateZipperBuyPayoutLogs',
                    formData,
                    '',
                    'transaction'
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <SellerPayoutContext.Provider
            value={{
                all_payment: state.all_payment,
                all_trans: state.all_trans,
                responseStatus: state.responseStatus,
                all_trans_zb: state.all_trans_zb,
                all_payment_zb: state.all_payment_zb,
                clearResponse,
                getAllSellerPayoutLogsZb,
                getAllSellerPayoutLogs,
                getAllTransaction,
                getAllTransactionZb,
                sellerTransfer,
                updateInvoiceSellerStatus,
                updateSellerPayoutLogs,
                updateZipperBuyPayoutLogs,
            }}
        >
            {props.children}
        </SellerPayoutContext.Provider>
    )
}

export default TransactionState
